import { get } from "@bigyouth/base";

import { FORM_ACTIONS } from "./formValidation";
import { ACTIONS as MODAL_ACTIONS } from "./modal";

import axios from "axios";
import { get as getPipe } from "../utils/sigpipe";

export default {
  name: "form",

  trackingAction: null,
  trackingCategory: null,
  trackingLabelSuccess: null,
  trackingLabelError: null,

  ui: {
    btSubmit: "[js-form-submit]",
  },

  componentDidMount() {
    const formId = this.el.getAttribute("data-form-id");

    switch (this.props.type) {
      case "qualif":
        this.trackingAction = "formulaire-etape-5";
        this.trackingCategory = "contact";
        this.trackingLabelSuccess = "envoyer-ok";
        this.trackingLabelError = "envoyer-nok";
        break;
      case "newsletter":
        this.trackingAction = "newsletter";
        this.trackingCategory = "contact";
        this.trackingLabelSuccess = "m'inscrire-ok";
        this.trackingLabelError = "m'inscrire-nok";
        break;
      case "contact":
        this.trackingAction = "formulaire-etape-0";
        this.trackingCategory = "contact";
        this.trackingLabelSuccess = "envoyer-ok";
        this.trackingLabelError = "envoyer-nok";
        break;
      case "offer":
        this.trackingAction = "formulaire-recrutement";
        this.trackingCategory = "recrutement";
        this.trackingLabelSuccess = "envoyer-candidature-ok";
        this.trackingLabelError = "envoyer-candidature-nok";
        break;
    }

    if (formId) {
      this.pipe = getPipe(formId);

      if (this.pipe) {
        this.pipe.on(({ action, formData }) => {
          switch (action) {
            case FORM_ACTIONS.SUBMIT: {
              this.ui.btSubmit.setAttribute("disabled", "disabled");

              const formDataNew = new FormData();

              for (const [key, value] of Object.entries(formData)) {
                if (
                  key === "application[resume]" ||
                  key === "application[otherResume]"
                ) {
                  formDataNew.append(
                    key,
                    this.el.querySelector(`[name="${key}"]`).files[0],
                  );
                } else if (!key.includes("rgpd-conscent")) {
                  formDataNew.append(key, value);
                }
              }

              axios
                .post(this.props.route, formDataNew, {})
                .then((response) => {
                  if (response.data.success) {
                    this.el.reset();
                    this.el.querySelectorAll("select").forEach((el) => {
                      const csSelect = el.customSelect;
                      csSelect.value = csSelect.select.options[0];
                    });
                    this.ui.btSubmit.removeAttribute("disabled");

                    if (this.props.onSuccess) {
                      this.manageSuccess();
                    }

                    if (
                      typeof _paq !== "undefined" &&
                      this.props.type !== "whitebook"
                    ) {
                      _paq.push([
                        "trackEvent",
                        this.trackingCategory,
                        this.trackingAction,
                        this.trackingLabelSuccess,
                      ]);
                    }
                  } else {
                    if (
                      typeof _paq !== "undefined" &&
                      this.props.type !== "whitebook"
                    ) {
                      _paq.push([
                        "trackEvent",
                        this.trackingCategory,
                        this.trackingAction,
                        this.trackingLabelError,
                      ]);
                    }
                  }
                })
                .catch((e) => {
                  if (e.response) {
                    this.ui.btSubmit.removeAttribute("disabled");
                    const error = document.createElement("div");
                    error.classList.add("form__error");
                    error.setAttribute("js-form-error", "");
                    let errorMsg = "Erreur : ";

                    if (e.response.data.errors) {
                      for (const value of Object.values(
                        e.response.data.errors,
                      )) {
                        value.forEach((el) => {
                          errorMsg += `${config.trads[el]}<br/>`;
                        });
                      }
                    } else {
                      errorMsg += e.message;
                    }
                    error.innerHTML = errorMsg;
                    const errorWrap = this.el.querySelector(
                      "[js-form-error-wrap]",
                    );
                    errorWrap.parentNode.insertBefore(error, errorWrap);
                  }

                  if (
                    typeof _paq !== "undefined" &&
                    this.props.type !== "whitebook"
                  ) {
                    _paq.push([
                      "trackEvent",
                      this.trackingCategory,
                      this.trackingAction,
                      this.trackingLabelError,
                    ]);
                  }
                });
              break;
            }

            case FORM_ACTIONS.ERROR: {
              console.warn(
                `form ${this.pipe.id} contains errors in these values:`,
                formData,
              );

              if (
                typeof _paq !== "undefined" &&
                this.props.type !== "whitebook"
              ) {
                _paq.push([
                  "trackEvent",
                  this.trackingCategory,
                  this.trackingAction,
                  this.trackingLabelError,
                ]);
              }

              break;
            }
          }
        });
      }
    }
  },

  manageSuccess() {
    const s = this.props.onSuccess;

    if (s.closeModal) {
      const modal = get(`#${s.closeModal}`);
      const pipe = getPipe(modal.getAttribute("data-pipe-id"));
      pipe.write({ action: MODAL_ACTIONS.CLOSE });
    }

    if (s.openModal) {
      const modal = get(`#${s.openModal}`);
      const pipe = getPipe(modal.getAttribute("data-pipe-id"));
      pipe.write({ action: MODAL_ACTIONS.OPEN });
    }

    if (s.goTo) {
      if (s.goTo === "nextSlide") {
        const swiper = this.el.swiper;
        swiper.slideNext();
      } else {
        window.location.href = s.goTo;
      }
    }

    if (s.displayElement) {
      document
        .querySelector(`#${s.displayElement}`)
        .classList.remove("is-hidden");
    }

    if (s.hideElement) {
      document.querySelector(`#${s.hideElement}`).classList.add("is-hidden");
    }
  },
};

document.addEventListener("DOMContentLoaded", function () {
  // Gestion du clic sur le bouton "Voir plus" pour afficher/masquer le contenu RGPD
  const voirPlusButton = document.querySelector(".voirPlusNewsletter");
  const consentPlusElement = document.querySelector(".consentPlus");
  const consentTopElement = document.querySelector(".consentTop");
  const consentFormItem = document.querySelector(".items-start");

  if (voirPlusButton && consentPlusElement) {
    voirPlusButton.addEventListener("click", (e) => {
      e.preventDefault();
      consentPlusElement.style.display = "block";
      const height = consentPlusElement.scrollHeight;
      consentPlusElement.style.height = "0";
      consentPlusElement.style.overflow = "hidden";
      consentPlusElement.style.transition = "height 0.3s ease";

      setTimeout(() => {
        consentPlusElement.style.height = height + "px";
      }, 10);

      voirPlusButton.style.display = "none";

      setTimeout(() => {
        consentPlusElement.style.height = "auto";
      }, 300);
    });
  }
  if (voirPlusButton && consentPlusElement) {
    document.addEventListener(
      "wpcf7invalid",
      function (event) {
        $(".wpcf7-response-output").addClass("alert alert-danger");
        consentPlusElement.style.display = "none";
        consentTopElement.style.display = "none";
        consentFormItem.style.display = "none";
      },
      false,
    );
    document.addEventListener(
      "wpcf7spam",
      function (event) {
        $(".wpcf7-response-output").addClass("alert alert-warning");
        consentPlusElement.style.display = "none";
        consentTopElement.style.display = "none";
        consentFormItem.style.display = "none";
      },
      false,
    );
    document.addEventListener(
      "wpcf7mailfailed",
      function (event) {
        $(".wpcf7-response-output").addClass("alert alert-warning");
        consentPlusElement.style.display = "none";
        consentTopElement.style.display = "none";
        consentFormItem.style.display = "none";
      },
      false,
    );
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        $(".wpcf7-response-output").addClass("alert alert-success");
        consentPlusElement.style.display = "none";
        consentTopElement.style.display = "none";
        consentFormItem.style.display = "none";
      },
      false,
    );
  }
});
